class Cloudflare {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.submitButton = self.elem.querySelector("[data-cf-turnstile-button]");
        self.token = null;
    }

    init() {
        let self = this;

        // Disable submit button by default
        if (self.submitButton) {
            self.submitButton.disabled = true;
        }

        // Create global callbacks (required for Turnstile)
        window.onTurnstileSuccess = (token) => {
            self.token = token;

            if (self.submitButton) {
                self.submitButton.disabled = false;
            }
        };

        window.onTurnstileExpired = () => {
            self.token = null;

            if (self.submitButton) {
                self.submitButton.disabled = true;
            }
        };

        // Guard against manual form submits
        self.elem.addEventListener("submit", (e) => {
            if (!self.token) {
                e.preventDefault();

                alert("Please confirm you are not a robot to continue.");
            }
        });
    }
}

export default Cloudflare;